import { useState, useContext } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';
import { Box, Button, Paper, styled, Typography } from '@mui/material'
import SearchBar from '../searchBar/SearchBar';
import { Add, CheckCircle, Remove } from '@mui/icons-material';
import sectorsByCategory from '../../../assets/data/category';


const SearchBox = styled(Box)(({theme}) => ({
  display: "flex",
  flexDirection: 'row',
  justifyContent: "space-between",
  alignItems: 'center',
  margin: theme.spacing(2),
  padding: theme.spacing(1),
  borderRadius: '5px',
  backgroundColor: '#242424',

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    justifyContent: "center",
  }
}));



const FilterByCategory = ({ category, selectedCategory, sectors, isOpen, onToggle, selectedFilter, handleFilterSelection, handleFilterByCategory, filterByCategory }) => {

  return (
    <Box sx={{ width: "100%", mb: 1 }}>
      <Box
        sx={{
          width: "100%",
          height: { mdlg: '4vh', lg: "5vh" },
          bgcolor: "#55d6aa",
          color: "#000",
          // borderBottom: selectedCategory === category ? '3px solid #f50057' :  "2px solid #000",
          borderBottom: filterByCategory === category ? '3px solid #f50057' :  "2px solid #000",
          borderRadius: "5px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography onClick={() => handleFilterByCategory(category)} sx={{ fontSize: { mdlg: '0.7rem', lg: '0.9rem' }, ml: 2, cursor: 'pointer' }}>{category}</Typography>
        {/* {!isOpen ? (
          <Add sx={{ mr: 2 }} onClick={onToggle} />
        ) : (
          <Remove sx={{ mr: 2 }} onClick={onToggle} />
        )} */}
      </Box>

      {isOpen && (
        <Box sx={{ width: "91%", px: 2, py: 1 }}>
          {sectors.map((sector, index) => (
            <Typography
              key={index}
              onClick={() => handleFilterSelection(sector, category)}
              sx={{
                fontSize: "0.8rem",
                my: 1,
                color: selectedFilter === sector ? '#f50057' : 'inherit',
                fontWeight: selectedFilter === sector ? 'bold' : 'normal',
                cursor: 'pointer'
              }}
            >
              {sector}
            </Typography>
          ))}
        </Box>
      )}
    </Box>
  );
}



function FilterSection() {

  const { selectedFilter, setSelectedFilter, setInputValue, filterByCategory, setFilterByCategory } = useContext(ThemeContext);
  const [selectedCategory, setSelectedCategory] = useState(null);
  
    const handleFilterByCategory = (category) => {
      setFilterByCategory(category);
    }

    const handleFilterSelection = (value, category) => {
      setSelectedFilter(value);
      setSelectedCategory(category);
    }
    
    const clearFilters = () => {
      setSelectedFilter(null);
      setSelectedCategory(null);
      setFilterByCategory(null);
      setInputValue('');
    }

  const [openCategory, setOpenCategory] = useState(null);

  const handleToggle = (category) => {
    setOpenCategory((prevCategory) => (prevCategory === category ? null : category));
  }

  return (
    <Box
      sx={{
        width: "100%",
        position: 'sticky',
        top: 50,
      }}
    >
      {/* <Paper elevation={2} sx={{ width: '100%', height: '100%', pt: 1, my: 2 }} > */}
        <SearchBox>
          <SearchBar width={{ mdlg: "18vw", lg: "15vw"}} height="5vh" />
          <Button variant="standard" onClick={clearFilters} sx={{ fontSize: '0.7rem', mt: { mdlg: 1, lg: 0 }, px: 1, fontWeight: '900', color: '#55d6aa' }} >Clear Filters</Button>
        </SearchBox>
      <Box sx={{ m: 2 }}>
        <Typography variant="body2" fontWeight={600} sx={{ mb: 1 }}>
          Available Regions
        </Typography>
        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: 1 }}>
            <CheckCircle sx={{ fontSize: { mdlg: '0.9rem', lg: "1rem" }, color: "red" }} />
            <Typography variant="body2" sx={{ fontSize: { mdlg: '0.73rem', lg: "0.9rem" } }} >North America</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: 1 }}>
            <CheckCircle sx={{ fontSize: { mdlg: '0.9rem', lg: "1rem" }, color: "red" }} />
            <Typography variant="body2" sx={{ fontSize: { mdlg: '0.73rem', lg: "0.9rem" } }} >Europe</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: 1 }}>
            <CheckCircle sx={{ fontSize: { mdlg: '0.9rem', lg: "1rem" }, color: "red" }} />
            <Typography variant="body2" sx={{ fontSize: { mdlg: '0.73rem', lg: "0.9rem" } }} >Asia Pacific</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: 1 }}>
            <CheckCircle sx={{ fontSize: { mdlg: '0.9rem', lg: "1rem" }, color: "red" }} />
            <Typography variant="body2" sx={{ fontSize: { mdlg: '0.73rem', lg: "0.9rem" } }} >South America</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: 1 }}>
            <CheckCircle sx={{ fontSize: { mdlg: '0.9rem', lg: "1rem" }, color: "red" }} />
            <Typography variant="body2" sx={{ fontSize: { mdlg: '0.73rem', lg: "0.9rem" } }} >Middle East & Africa</Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ m: 2 }}>
        <Typography variant="body2" fontWeight={600}>
          Filter by Category
        </Typography>
        <Box sx={{ m: 1, height: "60vh", overflowY: "auto",
          pr: '4px',
          scrollbarWidth: 'thin', // Firefox
          scrollbarColor: '#242424 transparent', // Firefox
          '&::-webkit-scrollbar': {
            width: '2px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#242424',
            borderRadius: '4px',
            opacity: 0,
            transition: 'opacity 0.3s',
          },
          '&:hover::-webkit-scrollbar-thumb': {
            opacity: 1,
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },

          // Firefox fallback: can't hide completely, but we make it thin
          scrollbarWidth: 'none',
          '&:hover': {
            scrollbarWidth: 'thin',
          },
          '&': {
            scrollbarColor: 'transparent transparent',
          },
          '&:hover': {
            scrollbarColor: '#55d6aa transparent',
          },
         }}>
          {Object.entries(sectorsByCategory).map(([category, sectors]) => (
            <FilterByCategory
              key={category}
              category={category}
              selectedCategory={selectedCategory}
              sectors={sectors}
              isOpen={openCategory === category}
              onToggle={() => handleToggle(category)}
              selectedFilter={selectedFilter}
              handleFilterSelection={handleFilterSelection}
              filterByCategory={filterByCategory}
              handleFilterByCategory={handleFilterByCategory}
            />
          ))}
        </Box>
      </Box>
      {/* </Paper> */}
    </Box>
  );
}

export default FilterSection